import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as InformationAction from 'store/actions/information';
import { Button } from 'reactstrap';
import List from './list';
import AddDialog from './addDialog';
import DeleteAllConfirm from './deleteAllConfirm';
import DetailDialog from './detailDialog';
import ConfirmDialog from 'components/Dialogs/ConfirmDialog';
import FilterBox from './filter';
import * as EmployeeAction from 'store/actions/employee';
import * as CustomDutyInvoiceAction from 'store/actions/customDutyInvoice';
import { useHistory } from 'react-router';
import { getHeaders } from './headers';
import queryString from 'query-string';
import * as CustomClearenceAction from 'store/actions/customClearence';
import { NotificationManager } from 'react-notifications';
import ReactToPrint from 'react-to-print';
import CustomDutyInvoicePrintComponent from './CustomDutyInvoicePrint/printComponent';
import { t } from 'i18next';
import useActionPermission from 'hooks/useActionPermission';
import useViewPermission from 'hooks/useViewPermission';

function CustomDutyInvoice() {
  const [modalOpen, setModalOpen] = React.useState(false);
  const [editData, setEditData] = React.useState(null);
  const [showDelete, setShowDelete] = React.useState(false);
  const [showDetail, setShowDetail] = React.useState(false);
  const [showDeleteAll, setShowDeleteAll] = React.useState(false);
  const [searchValue, setSearchValue] = React.useState(null);
  const [selectedData, setSelectedData] = React.useState([]);
  const [printData, setPrintData] = React.useState(null);

  const { canAdd, canEdit, canDelete } = useActionPermission('import_duty');

  const dispatch = useDispatch();
  const router = useHistory();

  const printRef = React.useRef();
  const printTriggerRef = React.useRef();
  
  const handlePrint = (data) => {
    setPrintData(data);
    // Wait for state to update, then trigger print
    setTimeout(() => {
      if (printTriggerRef.current) {
        printTriggerRef.current.click();
      }
    }, 100);
  };

  const customDutyInvoices = useSelector((state) => state.customDutyInvoice.customDutyInvoices);
  const actionLoading = useSelector((state) => state.loading.actionLoading);

  const { isOwn, isBranch } = useViewPermission('custom_duty_invoice');

  React.useEffect(() => {
    dispatch(InformationAction.getBranch());
    dispatch(EmployeeAction.getMarketingPerson());
    dispatch(CustomClearenceAction.getAll({}, true));
  }, [dispatch, InformationAction.getBranch]);

  React.useEffect(() => {
    loadData(searchValue);
  }, [CustomDutyInvoiceAction.getAll, router.location.search, searchValue]);

  const loadData = (value = null) => {
    setSearchValue(value);
    let query = { limit: 10, page: 1 };
    if (router.location.search) query = queryString.parse(router.location.search);

    if (isOwn()) query.isOwn = !!isOwn();
    if (isBranch()) query.isBranch = !!isBranch();

    dispatch(CustomDutyInvoiceAction.getAll(query, value ? value : searchValue ? searchValue : {}));
  };

  return (
    <>
      <List
        headers={getHeaders()}
        selectedData={selectedData}
        data={customDutyInvoices}
        onToggle={(e) => handlePrint(e)}
        canEdit={canEdit}
        canDelete={canDelete}
        onEdit={(e) => {
          setEditData(e);
            setTimeout(() => {
              setModalOpen(true);
            }, 1000);
        }}
        onDelete={(e) => {
          setEditData(e);
          setTimeout(() => {
            setShowDelete(true);
          }, 1000);
        }}
        onSelect={(e) => {
          if (selectedData.find((s) => s._id === e._id)) setSelectedData(selectedData.filter((s) => s._id !== e._id));
          else setSelectedData([...selectedData, e]);
        }}
        showDetail={(e) => {
          setEditData(e);
          setShowDetail(true);
        }}
        filter={
          <FilterBox
            onSearch={(value) => {
              setSelectedData([]);
              loadData(value);
            }}
          />
        }
        buttons={
          <>
       
              <Button
                style={{ width: 100 }}
                size='sm'
                disabled={!canAdd()}
                onClick={() => {
                  setModalOpen(true);
                  setEditData(null);
                }}
              >
                <i className='fa fa-plus mr-2' />
                {t('add')}
              </Button>
          
            <Button
              style={{ width: 100 }}
              size='sm'
              disabled={actionLoading}
              onClick={() => {
                const query = {};
                if (isOwn()) query.isOwn = !!isOwn();
                if (isBranch()) query.isBranch = !!isBranch();
                dispatch(CustomDutyInvoiceAction.exportData(searchValue ? { ...searchValue, ...query } : query));
              }}
            >
              {actionLoading ? <i className='fa fa-spinner mr-2' /> : <i className='fa fa-file-excel mr-2' />}

              {t('export')}
            </Button>
            <Button
              style={{ width: 120 }}
              size='sm'
              disabled={actionLoading}
              onClick={() => {
                const query = {};
                if (isOwn()) query.isOwn = !!isOwn();
                if (isBranch()) query.isBranch = !!isBranch();
                dispatch(CustomDutyInvoiceAction.exportDataItems(searchValue ? { ...searchValue, ...query } : query));
              }}
            >
              {actionLoading ? <i className='fa fa-spinner mr-2' /> : <i className='fa fa-file-excel mr-2' />}

              Export Items
            </Button>
            <Button
              style={{ width: 100 }}
              size='sm'
              onClick={() => {
                window.location = '/custom-duty-invoice';
              }}
            >
              <i className='fa fa-spinner mr-2' /> {t('refresh')}
            </Button>
          </>
        }
      />
      <AddDialog
        title={editData ? `${t('edit')} ${t('sidebar.custom_duty_invoice')}` : `${t('add')} ${t('sidebar.custom_duty_invoice')}`}
        editData={editData}
        modalOpen={modalOpen}
        onToggle={(open) => setModalOpen(open)}
        onSubmit={(values) => {
          if (editData) {
          
            values.isEdit = true;
            values.original_invoice_id=editData._id
          }

          dispatch(CustomDutyInvoiceAction.save(values));
        }}
      />
      <ConfirmDialog
        modalOpen={showDelete}
        title={`${t('delete')} ${t('sidebar.custom_duty_invoice')}`}
        body={`${t('confirm_delete')} ${editData?.invoice_number}?`}
        onToggle={() => setShowDelete(false)}
        onConfirm={() => {
          setShowDelete(false);
          dispatch(CustomDutyInvoiceAction.deleteData(editData?._id));
          setTimeout(() => loadData(), 1000);
        }}
      />
      <DeleteAllConfirm
        data={selectedData}
        modalOpen={showDeleteAll}
        title={`${t('delete')} ${t('sidebar.custom_duty_invoice')}`}
        body={`${t('confirm_delete')}?`}
        onToggle={() => setShowDeleteAll(false)}
        onConfirm={() => {
          setShowDeleteAll(false);
          setSelectedData([]);
          dispatch(CustomDutyInvoiceAction.deleteAllData({ invoice_id_list: selectedData }));
          setTimeout(() => loadData(), 1000);
        }}
        onRemoveSelected={(e) => {
          setSelectedData(selectedData.filter((s) => s._id !== e._id));
        }}
      />
      <DetailDialog
        data={editData}
        modalOpen={showDetail}
        onToggle={() => setShowDetail(false)}
      />
      {/* Hidden ReactToPrint component */}
      <div style={{ display: 'none' }}>
        <ReactToPrint
          trigger={() => <button ref={printTriggerRef}>Print</button>}
          content={() => printRef.current}
          documentTitle={`Custom_Duty_Invoice_${printData?.invoice_number || 'Document'}`}
          pageStyle={`
            @page { 
              size: A5 portrait; 
              margin: 10mm; 
            }
            @media print {
              body { 
                -webkit-print-color-adjust: exact;
                print-color-adjust: exact;
              }
            }
          `}
        />
        <div style={{ display: 'none' }}>
          <CustomDutyInvoicePrintComponent data={printData} ref={printRef} />
        </div>
      </div>
    </>
  );
}

export default CustomDutyInvoice;
